/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Col_McpInputs */

const en_hub_col_mcp = /** @type {(inputs: Hub_Col_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

const id_hub_col_mcp = /** @type {(inputs: Hub_Col_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

/**
* | output |
* | --- |
* | "MCP" |
*
* @param {Hub_Col_McpInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_col_mcp = /** @type {((inputs?: Hub_Col_McpInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Col_McpInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_col_mcp(inputs)
	return en_hub_col_mcp(inputs)
});